// extracted by mini-css-extract-plugin
module.exports = {"stylingWrapper":"styling_stylingWrapper__1i8Fk","demarcation-container":"styling_demarcation-container__4CGzN"};